export const addQueryParameters = (queryParameters: Record<string, string | undefined>, url: string) => {
  let newUrl: string;

  if (url.charAt(url.length - 1) === '?') {
    newUrl = url.substring(0, url.length - 1);
  } else {
    newUrl = url;
  }

  Object.keys(queryParameters).forEach((parameter, i) => {
    if (i === 0) {
      newUrl += `?${parameter}=${queryParameters[parameter]}&`;
    } else {
      newUrl += `${parameter}=${queryParameters[parameter]}&`;
    }
  });

  return newUrl.substring(0, newUrl.length); // newUrl.length - 1 idi.
};
